import { InputNumber } from "ant-design-vue";
const { ...other } = InputNumber;
const YwInputNumber = {
  ...other,
  name: "YwInputNumber",
};

YwInputNumber.install = function (Vue) {
  Vue.component(YwInputNumber.name, InputNumber);
};

export default YwInputNumber;